<template>
  <section v-if="content" ref="carousel" class="carousel splide mt-6">
      <div class="splide__arrows absolute inset-0 z-20 pointer-events-none">
          <fai class="splide__arrow splide__arrow--prev control control-left pointer-events-auto" icon="angle-left"></fai>
          <fai class="splide__arrow splide__arrow--next control control-right pointer-events-auto" icon="angle-right"></fai>
      </div>

      <div class="splide__track relative z-10">
          <ul class="splide__list">
              <li class="splide__slide relative cursor-pointer" v-for="item in content.items" :key="item._uid" @click="getStoryblokLink(item.link, item.target)">
                  <img
                      class="w-full h-full object-cover absolute inset-0"
                      :class="item.background_position"
                      loading="lazy" width="1200" height="600"
                      :src="item.img+'/m/1200x0'"
                      :srcset="item.img+'/m/1200x0 1200w,'+ item.img+'/m/600x0 600w'"
                      sizes="(max-width: 1200px) 95vw, 1200px"
                      alt=""
                  />

                  <div class="absolute inset-0 carousel-flex-end" v-if="item.title">
                    <div class="w-full bg-blue-600 bg-opacity-75 pt-4 pb-6 px-6 flex justify-center gap-4 md:gap-6" >
                      <h2 class="font-luckiest text-xl md:text-4xl text-white text-center">{{item.title}}</h2>
                      <fai class="icon text-green-600 text-2xl md:text-5xl" icon="chevron-right"></fai>
                    </div>
                  </div>
              </li>
          </ul>
      </div>
  </section>
</template>

<script>
import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide-core.min.css";
import storyblokLink from "@/mixins/storyblokLink";
export default {
    mixins: [storyblokLink],
    props: {
      content: {
        type: Object,
        default: null,
      },
    },
    mounted() {
      Splide.defaults = {
          type: "loop",
          perPage: 1,
          arrows: true,
          pagination: true,
          interval: (this.content.delay || 5) * 1000,
          autoplay: this.content.auto || false
      }
      let splide = new Splide(this.$refs.carousel)
      splide.mount();
    }
}
</script>

<style lang="scss">
.carousel {
  width: $content-width;
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
}

.carousel-flex-end {
  @apply flex items-end;
}

.splide__slide {
  height: 280px;

  @screen md {
    height: 600px;
  }
}

.control {
  font-size: 50px;
  color: #fff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  position: absolute;
  z-index: 3;
  top: calc(40% - 25px);
  stroke-linecap: butt;
  stroke: black;
  stroke-width: 5px;
  cursor: pointer;
  &.control-left {
    left: 10px;
  }
  &.control-right {
    right: 10px;
  }
}

.splide__pagination {
  position: absolute;
  bottom: 10px;
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  button {
    margin: 0 10px;
    cursor: pointer;
    width: 10px;
    height: 10px;
    display: block;
    background-color: transparent;
    border: 2px solid #fff;
    border-radius: 50%;
    transition: background-color 0.4s;
    &.is-active,
    &:hover {
        background-color: #fff;
    }
  }
}
</style>